<template>
  <Drawer
    placement="left"
    :closable="false"
    v-model="openPoint"
    width="280"
    draggable
    class="my-drawer"
    title="标注点"
  >
    <div id="pointList">
      <Input
        v-model="keyword"
        search
        placeholder="请输入关键字"
        @on-search="getList"
      ></Input>

      <ul>
        <li
          @click="clickItem(item)"
          v-for="(item, index) in tableData"
          :key="index"
          :class="{ active: item.select }"
        >
          {{ item.name }}
        </li>
      </ul>
      <Button
        long
        @click="checkAll"
        :disabled="selectData.length == 0"
        type="primary"
        >取消选择</Button
      >
    </div>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openPoint: false,
      tableData: [],
      selectData: [],
      isAll: false,
      keyword: "",
    };
  },
  methods: {
    open() {
      this.openPoint = true;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var arr = [];
        var arrid = [];
        for (const i in this.tableData) {
          if (this.tableData[i].select) {
            arr.push(this.tableData[i]);
            arrid.push(this.tableData[i].id);
          }
        }
        this.tableData = arr;
        for (const i in data) {
          if (!arrid.includes(data[i].id)) {
            data[i].select = false;
            this.tableData.push(data[i]);
          }
        }
      });
    },
    push() {
      this.selectData = []; //为了应付郑平客户。先注释这一行

      for (const i in this.tableData) {
        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
        }
      }
      if (this.selectData.length == this.tableData.length) {
        this.isAll = true;
      }
      this.$emit("points", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;
      this.push();
    },
    checkAll() {
      for (const i in this.tableData) {
        this.tableData[i].select = false;
      }
      this.selectData = [];
      this.$emit("points", this.selectData);
    },
  },
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
}
#pointList li.active {
  background: #d9ebfe;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pointList.vue